import React, { useState, useEffect, useRef } from "react";
import "./../../../../assets/css/purchase/form.css";

import InitialDataFormLayout from "../components/InitialDataFormLayout";
import {
  labelStyle,
  inputStyle,
  sectionHeaderStyle,
  sectionIconStyle,
  sectionTitleStyle,
} from "../components/formStyles";
import api from "../../../../utils/axios";
import SearchableSelect from "../../../components/SearchableSelect";

import {
  deleteData,
  getAlert,
  insertData,
  updateData,
  getData,
} from "../../../../utils/SamuiUtils";

const CompanyForm = ({
  callInitialize,
  mode,
  name,
  formData,
  setFormData,
  selectedData,
}) => {
  const [initialFormData, setInitialFormData] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const isSavingRef = useRef(false);
  const [provinces, setProvinces] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [subdistricts, setSubdistricts] = useState([]);
  const [selProvinceId, setSelProvinceId] = useState("");
  const [selDistrictId, setSelDistrictId] = useState("");
  const [selSubdistrictId, setSelSubdistrictId] = useState("");

  const handleBack = () => {
    window.location.href = "/company";
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (
        event.target.tagName === "INPUT" ||
        event.target.tagName === "TEXTAREA" ||
        event.target.tagName === "SELECT"
      ) {
        return;
      }

      if (event.key === "Escape") {
        event.preventDefault();
        getAlert("C_DIALOG", "ต้องการยกเลิกการทำงานหรือไม่?", (isConfirm) => {
          if (isConfirm) {
            handleBack();
          }
        });
      }

      if (event.key === "F10") {
        event.preventDefault();
        if (!isSavingRef.current) handleSubmit();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [formData]);

  useEffect(() => {
    const compId = localStorage.getItem("company");
    if (compId) {
      setFormData((prevData) => ({
        ...prevData,
        Comp_id: compId,
      }));
    }
  }, [setFormData]);

  useEffect(() => {
    const defaultData = {
      Comp_id: window.localStorage.getItem("company") || "",
      Comp_Code: "",
      Comp_Name_TH: "",
      Comp_Name_EN: "",
      Comp_ShortName: "",
      Comp_TaxNo: "",
      Comp_Add1: "",
      Comp_Add2: "",
      Comp_Add3: "",
      Comp_Province: "",
      Comp_Post: "",
      Comp_Tel1: "",
      Comp_Tel2: "",
      Comp_Contact1: "",
      Comp_Contact2: "",
    };

    if (mode === "I") {
      setFormData(defaultData);
      setInitialFormData(defaultData);
      return;
    }

    if (mode === "U" && selectedData) {
      const editData = {
        Comp_id: selectedData.Comp_Id || selectedData.Comp_id || window.localStorage.getItem("company") || "",
        Comp_Code: selectedData.Comp_Code || "",
        Comp_Name_TH: selectedData.Comp_Name_TH || "",
        Comp_Name_EN: selectedData.Comp_Name_EN || "",
        Comp_ShortName: selectedData.Comp_ShortName || "",
        Comp_TaxNo: selectedData.Comp_TaxNo || "",
        Comp_Add1: selectedData.Comp_Add1 || "",
        Comp_Add2: selectedData.Comp_Add2 || "",
        Comp_Add3: selectedData.Comp_Add3 || "",
        Comp_Province: selectedData.Comp_Province || "",
        Comp_Post: selectedData.Comp_Post || "",
        Comp_Tel1: selectedData.Comp_Tel1 || "",
        Comp_Tel2: selectedData.Comp_Tel2 || "",
        Comp_Contact1: selectedData.Comp_Contact1 || "",
        Comp_Contact2: selectedData.Comp_Contact2 || "",
      };

      setFormData(editData);
      setInitialFormData(editData);
    }
  }, [mode, selectedData, setFormData]);

  useEffect(() => {
    api.get("/provinces").then((r) => setProvinces(r.data.data || []));
  }, []);

  useEffect(() => {
    if (!provinces.length) return;
    if (formData.Comp_Province) {
      const p = provinces.find((x) => x.NameInThai === formData.Comp_Province);
      if (p) {
        setSelProvinceId(p.ProvinceId);
        api.get(`/districts/${p.ProvinceId}`).then((r) => setDistricts(r.data.data || []));
      }
    }
  }, [provinces]);

  useEffect(() => {
    if (!districts.length) return;
    if (formData.Comp_Add3) {
      const d = districts.find((x) => x.NameInThai === formData.Comp_Add3);
      if (d) {
        setSelDistrictId(d.DistrictId);
        api.get(`/subdistricts/${d.DistrictId}`).then((r) => setSubdistricts(r.data.data || []));
      }
    }
  }, [districts]);

  useEffect(() => {
    if (!subdistricts.length) return;
    if (formData.Comp_Add2) {
      const s = subdistricts.find((x) => x.NameInThai === formData.Comp_Add2);
      if (s) {
        setSelSubdistrictId(s.SubdistrictId);
        setFormData((prev) => ({ ...prev, Comp_Post: s.ZipCode || prev.Comp_Post }));
      }
    }
  }, [subdistricts]);

  const handleChange = (event) => {
    const { name: fieldName, value } = event.target;

    const formatPhone = (v) => {
      const digits = String(v).replace(/\D/g, "").slice(0, 10);
      if (digits.length <= 3) return digits;
      return digits.slice(0, 3) + '-' + digits.slice(3);
    };

    const formatTaxId = (v) => {
      let d = String(v).replace(/\D/g, "").slice(0, 13);
      const parts = [];
      const pattern = [1, 4, 5, 2, 1];
      let pos = 0;
      for (let len of pattern) {
        if (pos >= d.length) break;
        const take = Math.min(len, d.length - pos);
        parts.push(d.substr(pos, take));
        pos += take;
      }
      return parts.join('-');
    };

    if (fieldName === 'Comp_Tel1' || fieldName === 'Comp_Tel2') {
      const formatted = formatPhone(value);
      setFormData((prev) => ({ ...prev, [fieldName]: formatted }));
      return;
    }

    if (fieldName === 'Comp_TaxNo') {
      const formatted = formatTaxId(value);
      setFormData((prev) => ({ ...prev, [fieldName]: formatted }));
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  const handleInsertCompany = async () => {
    try {
      const { Comp_id, ...dataToInsert } = formData;
      const fields = Object.keys(dataToInsert).join(", ");
      const values = Object.values(dataToInsert);

      await insertData("Tb_Set_Company", fields, values);
      await callInitialize();
    } catch (error) {
      console.error("Error in handleInsertCompany:", error);
      getAlert("FAILED", "ไม่สามารถบันทึกข้อมูลได้");
    }
  };

  const formatValues = (data) => {
    const { Comp_id, ...rest } = data;
    return rest;
  };

  const handleUpdateCompany = async () => {
    try {
      const where = { Comp_id: formData.Comp_id };
      const values = formatValues(formData);
      const res = await updateData("Tb_Set_Company", values, where);
      if (res) {
        await callInitialize();
      }
    } catch (error) {
      getAlert(
        "FAILED",
        "ไม่สามารถอัปเดตข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว"
      );
      return null;
    }
  };

  const handleDelete = async () => {
    try {
      getAlert("C_DIALOG", "ยืนยันการลบข้อมูล", async (isConfirm) => {
        if (!isConfirm) return;

        if (!selectedData || (selectedData.Comp_Id === undefined || selectedData.Comp_Id === null)) {
          getAlert("WARNING", "ไม่พบข้อมูลที่จะลบ");
          return;
        }

        const compId = selectedData.Comp_Id;
        const whereClause = isNaN(Number(compId))
          ? `WHERE Comp_Id = '${compId}'`
          : `WHERE Comp_Id = ${Number(compId)}`;

        const res = await deleteData("Tb_Set_Company", whereClause);

        if (res && res.status === "FAILED") {
          getAlert("FAILED", res.message || "ไม่สามารถลบข้อมูลได้ กรุณาลองใหม่อีกครั้ง");
          return;
        }

        if (typeof callInitialize === "function") {
          await callInitialize();
        }
      });
    } catch (error) {
      console.error("handleDelete error:", error);
      getAlert("FAILED", "ไม่สามารถลบข้อมูลได้ กรุณาลองใหม่อีกครั้ง");
    }
  };

  const handleSubmit = async () => {
    if (isSavingRef.current) return;

    try {
      if (formData.Comp_TaxNo && String(formData.Comp_TaxNo).length !== 13) {
        getAlert("WARNING", "เลขประจำตัวผู้เสียภาษีต้องมี 13 ตัว");
        return;
      }

      isSavingRef.current = true;
      setIsSaving(true);

      if (mode === "I" && formData.Comp_Code && String(formData.Comp_Code).trim() !== "") {
        try {
          const all = await getData("Tb_Set_Company", "1=1");
          const codeInput = String(formData.Comp_Code).trim().toLowerCase();
          const found = Array.isArray(all) && all.some((r) => String(r.Comp_Code || "").trim().toLowerCase() === codeInput);
          if (found) {
            getAlert("WARNING", "รหัสอ้างอิงบริษัทซ้ำ กรุณาใช้รหัสอื่น");
            isSavingRef.current = false;
            setIsSaving(false);
            return;
          }
        } catch (err) {
          console.error("Error checking Comp_Code:", err);
        }
      }

      if (formData.Comp_Name_TH && String(formData.Comp_Name_TH).trim() !== "") {
        try {
          const all = await getData("Tb_Set_Company", "1=1");
          const nameInput = String(formData.Comp_Name_TH).trim().toLowerCase();
          const matches = Array.isArray(all)
            ? all.filter((r) => String(r.Comp_Name_TH || "").trim().toLowerCase() === nameInput)
            : [];
          if (matches.length > 0) {
            if (mode === "I") {
              getAlert("WARNING", "ชื่อบริษัทภาษาไทยนี้ถูกใช้งานแล้ว กรุณาตรวจสอบ");
              isSavingRef.current = false;
              setIsSaving(false);
              return;
            } else if (mode === "U") {
              const others = matches.filter((r) => {
                const recordId = String(r.Comp_id ?? r.Comp_Id ?? "");
                const formId = String(formData.Comp_id ?? formData.Comp_Id ?? "");
                return recordId !== formId;
              });
              if (others.length > 0) {
                getAlert("WARNING", "ชื่อบริษัทภาษาไทยนี้ถูกใช้งานแล้ว กรุณาตรวจสอบ");
                isSavingRef.current = false;
                setIsSaving(false);
                return;
              }
            }
          }
        } catch (err) {
          console.error("Error checking Comp_Name_TH:", err);
        }
      }

      if (mode === "I") {
        await handleInsertCompany();
      } else if (mode === "U") {
        await handleUpdateCompany();
      }
      await callInitialize();
      setFormData({
        Comp_id: window.localStorage.getItem("company") || "",
        Comp_Code: "",
        Comp_Name_TH: "",
        Comp_Name_EN: "",
        Comp_ShortName: "",
        Comp_TaxNo: "",
        Comp_Add1: "",
        Comp_Add2: "",
        Comp_Add3: "",
        Comp_Province: "",
        Comp_Post: "",
        Comp_Tel1: "",
        Comp_Tel2: "",
        Comp_Contact1: "",
        Comp_Contact2: "",
      });
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      getAlert("FAILED", "ไม่สามารถบันทึกข้อมูลได้");
    } finally {
      isSavingRef.current = false;
      setIsSaving(false);
    }
  };

  const handleReset = () => {
    setFormData(initialFormData);
    if (mode === "U") {
      setDistricts([]);
      setSubdistricts([]);

      if (initialFormData.Comp_Province && provinces && provinces.length) {
        const p = provinces.find((x) => x.NameInThai === initialFormData.Comp_Province);
        if (p) {
          setSelProvinceId(p.ProvinceId);
          api.get(`/districts/${p.ProvinceId}`).then((r) => {
            const ds = r.data.data || [];
            setDistricts(ds);
            if (initialFormData.Comp_Add3) {
              const d = ds.find((x) => x.NameInThai === initialFormData.Comp_Add3);
              if (d) {
                setSelDistrictId(d.DistrictId);
                api.get(`/subdistricts/${d.DistrictId}`).then((rs) => {
                  const ss = rs.data.data || [];
                  setSubdistricts(ss);
                  if (initialFormData.Comp_Add2) {
                    const s = ss.find((x) => x.NameInThai === initialFormData.Comp_Add2);
                    if (s) setSelSubdistrictId(s.SubdistrictId);
                  }
                });
              }
            }
          });
        } else {
          setSelProvinceId("");
          setSelDistrictId("");
          setSelSubdistrictId("");
        }
      } else {
        setSelProvinceId("");
        setSelDistrictId("");
        setSelSubdistrictId("");
      }
    } else {
      setSelProvinceId("");
      setSelDistrictId("");
      setSelSubdistrictId("");
      setDistricts([]);
      setSubdistricts([]);
    }
  };

  return (
    <InitialDataFormLayout
      name={name}
      entityPath="/company"
      mode={mode}
      onSubmit={handleSubmit}
      isSubmittingDisabled={isSaving}
      onBack={handleBack}
      onReset={handleReset}
      onDelete={mode === "U" ? handleDelete : undefined}
      callInitialize={callInitialize}
    >
      <div className="mb-5">
        <div style={sectionHeaderStyle}>
          <i className="fas fa-building" style={sectionIconStyle}></i>
          <h5 style={sectionTitleStyle}>ข้อมูลบริษัท</h5>
        </div>
        <div className="row g-4">
          <div className="col-md-6">
            <label style={labelStyle}>รหัสอ้างอิงบริษัท</label>
            <input
              type="text"
              className="form-control"
              name="Comp_Code"
              value={formData.Comp_Code || ""}
              onChange={handleChange}
              style={inputStyle}
              maxLength={20}
            />
          </div>
          <div className="col-md-6">
            <label style={labelStyle}>เลขภาษี</label>
            <input
              type="text"
              className="form-control"
              name="Comp_TaxNo"
              value={formData.Comp_TaxNo || ""}
              onChange={handleChange}
              style={inputStyle}
              maxLength={13}
            />
          </div>
          <div className="col-md-4">
            <label style={labelStyle}>ชื่อบริษัทภาษาไทย</label>
            <input
              type="text"
              className="form-control"
              name="Comp_Name_TH"
              value={formData.Comp_Name_TH || ""}
              onChange={handleChange}
              style={inputStyle}
            />
          </div>
          <div className="col-md-4">
            <label style={labelStyle}>ชื่อบริษัทภาษาอังกฤษ</label>
            <input
              type="text"
              className="form-control"
              name="Comp_Name_EN"
              value={formData.Comp_Name_EN || ""}
              onChange={handleChange}
              style={inputStyle}
            />
          </div>
          <div className="col-md-4">
            <label style={labelStyle}>ชื่อบริษัทแบบย่อ</label>
            <input
              type="text"
              className="form-control"
              name="Comp_ShortName"
              value={formData.Comp_ShortName || ""}
              onChange={handleChange}
              style={inputStyle}
            />
          </div>
        </div>
      </div>

      <div className="mb-5">
        <div style={sectionHeaderStyle}>
          <i className="fas fa-map-marker-alt" style={sectionIconStyle}></i>
          <h5 style={sectionTitleStyle}>ที่อยู่บริษัท</h5>
        </div>
        <div className="row g-4">
          <div className="col-lg-4 col-md-6">
            <label style={labelStyle}>จังหวัด</label>
            <SearchableSelect
              value={selProvinceId}
              options={provinces.map((p) => ({ value: p.ProvinceId, label: p.NameInThai }))}
              placeholder="เลือกจังหวัด"
              searchPlaceholder="ค้นหาจังหวัด..."
              onChange={async (v, opt) => {
                setSelProvinceId(v);
                setFormData((prev) => ({ ...prev, Comp_Province: opt?.label || "", Comp_Add3: "", Comp_Add2: "", Comp_Post: "" }));
                setDistricts([]);
                setSubdistricts([]);
                if (v) {
                  const res = await api.get(`/districts/${v}`);
                  setDistricts(res.data.data || []);
                }
              }}
            />
          </div>

          <div className="col-lg-4 col-md-6">
            <label style={labelStyle}>เขต/อำเภอ</label>
            <SearchableSelect
              value={selDistrictId}
              options={districts.map((d) => ({ value: d.DistrictId, label: d.NameInThai }))}
              placeholder="เลือกอำเภอ"
              searchPlaceholder="ค้นหาอำเภอ..."
              disabled={!districts.length}
              onChange={async (v, opt) => {
                setSelDistrictId(v);
                setFormData((prev) => ({ ...prev, Comp_Add3: opt?.label || "", Comp_Add2: "", Comp_Post: "" }));
                setSubdistricts([]);
                if (v) {
                  const res = await api.get(`/subdistricts/${v}`);
                  setSubdistricts(res.data.data || []);
                }
              }}
            />
          </div>

          <div className="col-lg-4 col-md-6">
            <label style={labelStyle}>แขวง/ตำบล</label>
            <SearchableSelect
              value={selSubdistrictId}
              options={subdistricts.map((s) => ({ value: s.SubdistrictId, label: s.NameInThai }))}
              placeholder="เลือกตำบล"
              searchPlaceholder="ค้นหาตำบล..."
              disabled={!subdistricts.length}
              onChange={(v, opt) => {
                const selected = subdistricts.find((s) => String(s.SubdistrictId) === String(v));
                setSelSubdistrictId(v);
                setFormData((prev) => ({ ...prev, Comp_Add2: opt?.label || (selected ? selected.NameInThai : ""), Comp_Post: selected ? selected.ZipCode : prev.Comp_Post }));
              }}
            />
          </div>

          <div className="col-lg-4 col-md-6">
            <label style={labelStyle}>รหัสไปรษณีย์</label>
            <input
              type="text"
              className="form-control"
              name="Comp_Post"
              value={formData.Comp_Post || ""}
              onChange={handleChange}
              style={inputStyle}
              maxLength={10}
            />
          </div>
        </div>
      </div>

      <div>
        <div style={sectionHeaderStyle}>
          <i className="fas fa-phone-alt" style={sectionIconStyle}></i>
          <h5 style={sectionTitleStyle}>ข้อมูลการติดต่อ</h5>
        </div>
        <div className="row g-4">
          <div className="col-md-6">
            <label style={labelStyle}>ติดต่อ</label>
            <input
              type="text"
              className="form-control"
              name="Comp_Contact1"
              value={formData.Comp_Contact1 || ""}
              onChange={handleChange}
              style={inputStyle}
            />
          </div>
          <div className="col-md-6">
            <label style={labelStyle}>เบอร์โทร</label>
            <input
              type="text"
              className="form-control"
              name="Comp_Tel1"
              value={formData.Comp_Tel1 || ""}
              onChange={handleChange}
              style={inputStyle}
              maxLength={11}
            />
          </div>
          <div className="col-md-6">
            <label style={labelStyle}>ติดต่อ 2</label>
            <input
              type="text"
              className="form-control"
              name="Comp_Contact2"
              value={formData.Comp_Contact2 || ""}
              onChange={handleChange}
              style={inputStyle}
            />
          </div>
          <div className="col-md-6">
            <label style={labelStyle}>เบอร์โทร 2</label>
            <input
              type="text"
              className="form-control"
              name="Comp_Tel2"
              value={formData.Comp_Tel2 || ""}
              onChange={handleChange}
              style={inputStyle}
              maxLength={11}
            />
          </div>
        </div>
      </div>
    </InitialDataFormLayout>
  );
};

export default CompanyForm;
